import FormattedMessage from 'I18n/components/FormattedMessage';
import { useSelector } from 'react-redux';
import { getMarketerSectionsCount, getMarketerSectionsLimit } from 'ContentEditorUI/redux/selectors/templateInfoSelectors';
import { shouldShowSection } from 'ContentEditorUI/utils/sidebarUtil';

/* TODO  type section after migrated to immer as section is now immutable map but will be migrated to immer */
import { jsx as _jsx } from "react/jsx-runtime";
export const useFilterSections = (sections, query) => {
  if (query === '' || !sections) {
    return sections;
  }
  return sections.filter(section => shouldShowSection(query, section));
};

/**
 *
 * @param {*} marketerSectionsLimitInfo
 * @returns [`alertType`, `alertMessage`, `alertTitle`]
 */

export const useMarketerSectionsAlertTypeMessageAndTitle = marketerSectionsLimitInfo => {
  const shouldShowMarketerSectionsLimitAlert = marketerSectionsLimitInfo.isAtLimit || marketerSectionsLimitInfo.isNearLimit || marketerSectionsLimitInfo.isOverLimit;
  const marketerSectionsCount = useSelector(getMarketerSectionsCount);
  const marketerSectionsLimit = useSelector(getMarketerSectionsLimit);
  if (!shouldShowMarketerSectionsLimitAlert) {
    return [null, null, null];
  }
  let message;
  let title;
  if (marketerSectionsLimitInfo.isAtLimit) {
    message = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "inpage.layout.addSection.atSavedSectionsLimit"
    });
    title = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "addSectionPanel.customSections.alertTitleAtLimit",
      options: {
        limit: marketerSectionsLimit
      }
    });
    return ['danger', message, title];
  } else if (marketerSectionsLimitInfo.isOverLimit) {
    message = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "addSectionPanel.customSections.overLimitWarning",
      options: {
        amountToDelete: marketerSectionsCount - marketerSectionsLimit,
        amount: marketerSectionsCount,
        limit: marketerSectionsLimit
      }
    });
    title = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "addSectionPanel.customSections.alertTitleOverLimit",
      options: {
        limit: marketerSectionsLimit
      }
    });
    return ['danger', message, title];
  }
  message = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "addSectionPanel.customSections.limitWarning",
    options: {
      amount: marketerSectionsCount,
      limit: marketerSectionsLimit
    }
  });
  title = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "addSectionPanel.customSections.alertTitleNearLimit",
    options: {
      limit: marketerSectionsLimit
    }
  });
  return ['warning', message, title];
};